/*global global, sessionStorage */
import { createIntl } from "react-intl";
import { getLanguage } from "co-addin-captions";
import { selectCpmUser } from "../../redux/feature/settings/configurations-slice";
import { store } from "../../redux/store/store";
import React from "react";
import { SeahorseDocumentLinked } from "../../api/models/seahorse-document-linked";

let intl;

function initIntl() {
  let selectedCpmUser = selectCpmUser(store.getState());
  if (selectedCpmUser) {
    intl = createIntl({
      locale: selectedCpmUser.preferredLanguage,
      messages: getLanguage(selectedCpmUser.preferredLanguage),
    });
    return intl;
  }
  if (global.Office && global.Office.context && global.Office.context.displayLanguage) {
    return createIntl({
      locale: global.Office.context.displayLanguage,
      messages: getLanguage(global.Office.context.displayLanguage),
    });
  }
}

export const descriptionLanguage = () => {
  let selectedCpmUser = selectCpmUser(store.getState());
  if (selectedCpmUser) {
    const language = selectedCpmUser.preferredLanguage.split("-");
    return language[0];
  }
  return null;
};

export function formatMessage(id: string) {
  if (!id) return "";
  const intlToUse = intl ?? initIntl();
  return intlToUse ? intlToUse.formatMessage({ id: id }) : id;
}

export function formatSehorseLastUpdateDate(date: SeahorseDocumentLinked[], driveItemId: string) {
  let selectedCpmUser = selectCpmUser(store.getState());
  let message = formatMessage("cof.seahorse.sent");
  let seahorseDocumentLinked = date?.find((item) => item?.driveItemId === driveItemId);
  if (!seahorseDocumentLinked) return "";
  let dateUpdate = new Intl.DateTimeFormat(selectedCpmUser.preferredLanguage, {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  }).format(new Date(seahorseDocumentLinked.date));
  return message + " " + dateUpdate;
}

export function formatMessageWithParams(id: string, params) {
  if (!id) return "";
  const intlToUse = intl ?? initIntl();
  return intlToUse ? intlToUse.formatMessage({ id: id }, params) : id;
}

export function tryFormatMessageWithJson(jsonInput: string) {
  if (!jsonInput) return "";
  try {
    let caption = JSON.parse(jsonInput);
    const intlToUse = intl ?? initIntl();
    return intlToUse ? intlToUse.formatMessage({ id: caption.key }, caption.params) : caption.key;
  } catch {
    return jsonInput;
  }
}

export function formatMessageDefault(id: string, defaultMessage: string) {
  if (!id) return "";
  if (intl == null) initIntl();
  return intl ? intl.formatMessage({ id: id, defaultMessage: defaultMessage }) : id;
}

export const escapeWithBreakLineAndTranslate = (data: string) => {
  return data
    .replace(/\$@(.*?)@\$/g, (_, s) => formatMessage(s))
    .split("||")
    .reduce((acc, v) => {
      acc.push(...v.split("<b>").map((v, i) => (i % 2 ? <b key={v + i}>{v}</b> : v)), <br />);
      return acc;
    }, [])
    .slice(0, -1);
};
export const getFormattedValue = (value: string | boolean | number) => {
  if (typeof value === "string") return value;
  if (typeof value === "number") return value.toString();
  if (typeof value === "boolean") return value ? "true" : "false";
  if (!value) return "";
  if (typeof value === "object") return JSON.stringify(value);
  return "UNHANDLED VALUE";
};
